export default "__VITE_ASSET__a695d27d__"